/**
 * Invitation paths and the short link's `?t=` query carry bearer credentials,
 * never telemetry dimensions. The bare `/h/{code}` stays: it names the huddle.
 * Covers the page (`/h/{code}?t=`), the API (`/api/huddles/link/{code}?t=`),
 * every repeated `t` parameter, and percent-encoded copies of all of them.
 */
export function redactHuddleInvitationUrl(value: string): string {
	return value
		.replace(/(\/(?:join|api\/huddles\/(?:guest|rsvp|join))\/)[^\s/?#"'<>\\]+/gi, '$1:token')
		.replace(/((?:%2f|%252f)(?:join|api(?:%2f|%252f)huddles(?:%2f|%252f)(?:guest|rsvp|join))(?:%2f|%252f))[^%\s&#"'<>]+/gi, '$1:token')
		.replace(/(?:\/h|\/api\/huddles\/link)\/[^\s"'<>]*/gi, (segment) => segment.replace(/([?&]t=)[^&#\s"'<>]*/gi, '$1:token'))
		.replace(/(?:%2f|%252f)(?:h|api(?:%2f|%252f)huddles(?:%2f|%252f)link)(?:%2f|%252f)[^\s"'<>]*/gi,
			(segment) => segment.replace(/((?:%3f|%26|%253f|%2526)t(?:%3d|%253d))(?:(?!%26|%23|%2526|%2523)[^\s"'<>])*/gi, '$1:token'));
}

/** PostHog also attaches referrers and URLs inside nested exception properties. */
export function redactHuddleInvitationValues<T>(value: T): T {
	if (typeof value === 'string') return redactHuddleInvitationUrl(value) as T;
	if (Array.isArray(value)) return value.map(redactHuddleInvitationValues) as T;
	if (value && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
		return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, redactHuddleInvitationValues(item)])) as T;
	}
	return value;
}
